import type { ReportSummary } from '@testflow/shared';
import { useTranslation } from 'react-i18next';
import { DonutChart } from '../donut-chart.js';

export function SimplificationCoverageCard({
  simplCoverage,
}: {
  simplCoverage: ReportSummary['simplificationCoverage'];
}) {
  const { t } = useTranslation();
  const donut = [
    { key: 'covered', value: simplCoverage.covered, token: 'pass' as const },
    { key: 'exception', value: simplCoverage.exception, token: 'warn' as const },
    { key: 'not_covered', value: simplCoverage.not_covered, token: 'open' as const },
  ];

  return (
    <section className="rounded-card border border-[var(--border)] bg-bg-surface p-4">
      <div className="mb-1 flex items-center justify-between">
        <h2 className="text-sm font-bold text-text-primary">{t('reporting.simplCoverage')}</h2>
        <span className="text-xs text-text-muted">
          {t('reporting.simplTotal', { total: simplCoverage.total })}
        </span>
      </div>
      <p className="mb-3 text-[10px] text-text-muted">{t('reporting.scopeProject')}</p>
      {/* Task 4 (#121): dieselbe Optik wie REP-1 (execution-status-card.tsx, Task 2) — Donut
          links, Legende mit farbigem Symbol + Klartext-Label + Zahl als zusammenhängende Gruppe
          daneben. Vorher drei `text-[28px]`-Zahlen in `grid-cols-3` über die volle Seitenbreite;
          bei nur noch halber Kartenbreite (Zwei-Spalten-Raster) wäre das zu breit geworden.
          `size={100}` statt der 120px-Vorgabe, weil auch der Donut selbst in die halbe Zeile
          passen muss. */}
      <div className="flex items-center gap-5">
        <DonutChart segments={donut} size={100} ariaLabel={t('reporting.simplCoverage')} />
        <ul className="space-y-1.5 text-xs">
          <li className="flex items-center gap-2">
            <span className="flex items-center gap-2 text-text-body">
              <span aria-hidden="true" className="text-status-pass">
                ●
              </span>
              {t('reporting.simplCovered')}
            </span>
            <span className="font-bold tabular-nums text-text-primary">
              {simplCoverage.covered}
            </span>
          </li>
          <li className="flex items-center gap-2">
            <span className="flex items-center gap-2 text-text-body">
              <span aria-hidden="true" className="text-status-warn">
                ●
              </span>
              {t('reporting.simplException')}
            </span>
            <span className="font-bold tabular-nums text-text-primary">
              {simplCoverage.exception}
            </span>
          </li>
          <li className="flex items-center gap-2">
            <span className="flex items-center gap-2 text-text-body">
              <span aria-hidden="true" className="text-[var(--status-open)]">
                ●
              </span>
              {t('reporting.simplNotCovered')}
            </span>
            <span className="font-bold tabular-nums text-text-primary">
              {simplCoverage.not_covered}
            </span>
          </li>
        </ul>
      </div>
    </section>
  );
}
